/* keep in sync with ./breakpoints.css */

export const SCREEN_XL = 1280;
export const SCREEN_LG = 1024;
export const SCREEN_MD = 768;
export const SCREEN_SM = 640;
export const SCREEN_XS = 360;
